import React from "react";
import HistoryHeader from "./historyHeader/HistoryHeader";
import BridgeHistoryTable from "./content/bridgeHistory/BridgeHistoryTable";

function HistoryContainer() {
  return (
    <div className=" flex flex-col h-full">
      {/* <div className=" border-b border-solid border-sunny-border dark: border-dark-border">
        <HistoryHeader />
      </div>  */}
      <div className=" flex-grow">
        <BridgeHistoryTable />
      </div>
    </div>
  );
}

export default HistoryContainer;
